import type { Viewer } from '@crm/contracts';
import { type ReactElement, useEffect } from 'react';
import { Link } from 'react-router';

import { paths } from '@/shared/config';
import { Dialog } from '@/shared/ui/dialog';
import { Icon } from '@/shared/ui/icon';

import styles from './AppShell.module.scss';
import { Sidebar } from './Sidebar';

interface ShellNavigationProps {
  viewer: Viewer;
  organizationId: number | null;
  open: boolean;
  onClose: () => void;
}

function Brand(): ReactElement {
  return (
    <Link to={paths.home} className={styles.brand} aria-label="CRM">
      <span className={styles.brandMark}>
        <Icon name="building" />
      </span>
      <span>
        CRM<span className={styles.brandDescription}>Управление компанией</span>
      </span>
    </Link>
  );
}

function useCloseOnDesktop(onClose: () => void): void {
  useEffect(() => {
    const desktop = window.matchMedia('(min-width: 961px)');
    const closeOnDesktop = () => {
      if (desktop.matches) onClose();
    };
    desktop.addEventListener('change', closeOnDesktop);
    return () => desktop.removeEventListener('change', closeOnDesktop);
  }, [onClose]);
}

export function ShellNavigation({
  viewer,
  organizationId,
  open,
  onClose,
}: ShellNavigationProps): ReactElement {
  useCloseOnDesktop(onClose);
  return (
    <>
      <aside className={styles.sidebar} aria-label="Навигация приложения">
        <Brand />
        <Sidebar viewer={viewer} organizationId={organizationId} onNavigate={onClose} />
        <p className={styles.sidebarFooter}>Техника · Склад · Команда</p>
      </aside>
      <Dialog open={open} onClose={onClose} title="Меню CRM" variant="drawer">
        <Sidebar viewer={viewer} organizationId={organizationId} onNavigate={onClose} />
      </Dialog>
    </>
  );
}
